// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6w-0";
export var startPickingButton = "_6w-1";